<template>
    <div>
        <div>
            <!-- 导航栏 -->
            <el-menu :default-active="activeIndex" class="el-menu-demo" style="background:#f2f2f2;display:flex;justify-content:center;align-items:center;" mode="horizontal" @select="handleSelect">
                <div style="margin-right:10px;font-size:13px;color:#999;">欢迎来到听说科技</div>
                <div style="margin:0 30px 0 10px;font-size:13px;color:#999;">欢迎您：{{this.userName}}</div>
                <el-menu-item index="1">
                    <router-link to="/refer">写作练习</router-link>
                </el-menu-item>
                <div>|</div>
                <el-menu-item index="2">
                    <router-link to="/articallist">我的文章</router-link>
                </el-menu-item>
                <div>|</div>
                <el-menu-item index="3">
                    <router-link to="/checkdetail">批改详情</router-link>
                </el-menu-item>
                <div>|</div>
                <el-menu-item index="4">
                    <router-link to="combo">我的套餐</router-link>
                </el-menu-item>
                <div>|</div>
                <el-menu-item index="5">
                    <router-link to="studentUser">用户中心</router-link>
                </el-menu-item>
                <div>|</div>
                <el-menu-item index="6">
                    <router-link to="studentShoppingCar">我的购物车</router-link>
                </el-menu-item>
                <div>|</div>
                <el-menu-item index="7">
                    <router-link to="/studentIndex">主页</router-link>
                </el-menu-item>
                <el-menu-item index="8">
                    <router-link to="/login">退出</router-link>
                </el-menu-item>
            </el-menu>
            <div style="width:100%;height:100%;margin-top:50px;">
                <div style="width:60%;margin-left:20%;">
                    <!-- logo + 输入框 + 购物车 -->
                    <div style="margin:45px 0;display:flex;justify-content:space-between;height:42px;align-items:center;">
                        <img src="../../assets/images/logo.png" alt="图片加载失败" >
                        <div style="width:600px;height:42px;border:1px solid #FF2832;display:flex;align-items:center;border-radius:3px;">
                            <img src="../../assets/images/search.png" alt="图片加载失败" style="margin:0 5px 0 10px;">
                            <input type="text" style="width:480px;height:40px;border:0;outline:none;">
                            <button style="width:120px;height:42px;border:0;background:#FF2832;">搜索</button>
                        </div>
                        <div style="display:flex;align-items:center;width:220px;height:40px;border:1px solid #dddddd;border-radius:3px;">
                            <img src="../../assets/images/shopping_car.png" alt="图片加载失败" style="width:25p;height:25px;margin:0 32px 0 8px">
                            <span style="font-size:16px;color:#999;">我的购物车</span>
                            <div style="margin-left:32px;width:43px;height:42px;background:#ff2832;line-height:40px;text-align:center;font-weight:bolder;">{{this.count}}</div>
                        </div>
                    </div>
                    <div style="width:100%;border-bottom:2px solid #999;margin-bottom:5px;font-size:25px;color:#333;">套餐详情</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            activeIndex:'4',
            userName:'张三',
            count:4,
        }
    },
    mounted(){},
    methods:{
        handleSelect(key,keyPath){
            console.log(key,keyPath)
        },
    }
}
</script>
<style scoped>
    a{
        display:inline-block;
        width:100%;height:100%;
        text-decoration: none;
    }
</style>